import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';
import routing from './yearly_demand_report.routes';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import PowerFormatter from '../../../components/logic/power-formatter/power-formatter.logic';
import chartConfig from './yearly_demand_report.config';

export class yearlyDemandReportController {
  /*@ngInject*/
  constructor($stateParams, $q, $filter, $state, moment, DateUtil, CsvUtil, PowerFormatter) {
    this.id = $stateParams.id;
    this.$q = $q;
    this.$filter = $filter;
    this.$state = $state;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.CsvUtil = CsvUtil;
    this.PowerFormatter = PowerFormatter;

    this.downloadFileName = 'demand_power.csv';

    this.chartConfig = chartConfig(this);
    this.billing_date = null;
  }

  $onInit() {
    this.parentComponent.saConfigPromise.then(config => {
      this.contractPower = config.contract_power;
      this.limitPower = config.limit_power;
      this.targetPower = config.target_power;
      this.billing_date = config.billing_date;

      this.createGraph();
    });
  }

  createGraph() {
    let contractPowers = [];
    let limitPowers = [];
    let targetPowers = [];
    for (let i = 0; i < 14; i++) {
      contractPowers.push(this.contractPower);
      limitPowers.push(this.limitPower);
      targetPowers.push(this.targetPower);
    }

    this.parentComponent.MonthlyMaxDemandPowerPromise.then(response => {
      this.chart.series[1].setData(targetPowers, false);
      this.chart.series[2].setData(limitPowers, false);
      this.chart.series[3].setData(contractPowers, false);

      let powers = response.powers;
      let lastDate = powers.length > 0 ?
        this.moment(powers[powers.length - 1].billing_date).subtract(1, 'days')
        : this.moment();
      lastDate.startOf('month');

      // UI 表示用
      this.startDate = this.createStart(this.billing_date);
      this.endDate = this.startDate.clone().add(12, 'months');
      this.categories = [];

      let start = this.createStart(this.billing_date);

      for (let i = 0; i < 13; i++) {
        this.categories.push(start.valueOf());
        start.add(1, 'month');
      }

      this.chart.xAxis[0].update({
        categories: this.categories,
        max: 12
      });

      this.demandPowerObjects = this.PowerFormatter.formatMonthlyDemandPowers(powers, this.categories, this.billing_date);
      this.demandPowers = this.demandPowerObjects.map(power => {return power.y});
      this.csvData = this.CsvUtil.processMonthlyMaxDemandPower(this.demandPowers, this.categories);
      this.chart.series[0].setData(this.demandPowerObjects);
      this.chart.reflow();
      this.maxPower = Math.max.apply(null, this.demandPowers);

      this.downloadFileName = `demand_power_${this.startDate.format('YYYY-MM')}_${this.endDate.format('YYYY-MM')}.csv`;
    });
  }

  createStart(configBillingDate) {
    const current = this.moment().startOf('month');
    if (configBillingDate === 1) {
      // 検針日が1日の場合、response.powersのbilling_dateが他の検針日のケースと異なり、必ず1ヶ月分先行する
      // グラフ表示の整合性を取るために、検針日に「99」を設定し後続の判定を回避させる
      configBillingDate = 99
    }

    if (this.moment().date() >= configBillingDate) {
      current.add(1, 'month');
    }

    return current.add(current.utcOffset(), 'minutes').utc().subtract(12, 'month');
  }
}

export default angular.module('leptonApp.yearlyDemandReport', [uiRouter, Chart, DateUtil, moment, CsvUtil, PowerFormatter])
  .config(routing)
  .component('yearlyDemandReport', {
    require: {parentComponent: '^demandReportShow'},
    template: require('./yearly_demand_report.html'),
    controller: yearlyDemandReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/yearly/yearly_demand_report.component.js